import { Model } from "vuex-fetch-factory";
import { PostManualRequest } from "../api";

export interface ManualRaw {
  id: number;
  name: string;
  description: string;
  tags: string[] | null;
  thumbnail: string;
  download_link: string;
}

export class ManualModel implements Model<ManualModel, ManualRaw> {
  public id = 0;
  public name = "";
  public description = "";
  public tags: string[] | null = [];
  public thumbnail = "";
  public download_link = "";

  public getNew(): ManualModel {
    return new ManualModel();
  }

  public fillModel(raw: ManualRaw): this {
    this.id = raw.id;
    this.name = raw.name;
    this.description = raw.description;
    this.tags = raw.tags;
    this.thumbnail = raw.thumbnail;
    this.download_link = raw.download_link;
    return this;
  }

  public getRaw(): ManualRaw {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      tags: this.tags,
      thumbnail: this.thumbnail,
      download_link: this.download_link
    };
  }

  public getIPostManualRequest(): PostManualRequest {
    return {
      name: this.name,
      description: this.description,
      tags: this.tags
    };
  }

  public getCopy(): ManualModel {
    return new ManualModel().fillModel(this.getRaw());
  }
}
